// extracted by mini-css-extract-plugin
module.exports = {"textAlignRight":"text_textAlignRight__3v89j","textAlignCenter":"text_textAlignCenter__1x44h","textAlignLeft":"text_textAlignLeft__29OQG"};